import { Flex, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

interface FormLabelWithHelpProps {
  label: string;
  help: string;
}

/** A form label followed by a `?` explaining what the field actually means. */
const FormLabelWithHelp: React.FC<FormLabelWithHelpProps> = ({ label, help }) => (
  <Flex align="center" gap={4}>
    {label}
    <Tooltip title={help}>
      <QuestionCircleOutlined style={{ color: '#8c8c8c' }} />
    </Tooltip>
  </Flex>
);

export default FormLabelWithHelp;
